import { createSlice } from "@reduxjs/toolkit";
import {
  fetchGrievances,
  createGrievance,
  updateGrievance,
  deleteGrievance,
} from "../thunks/grievanceThunks";

const grievanceSlice = createSlice({
  name: "grievances",
  initialState: {
    items: [],
    total: 0,
    page: 1,
    totalPages: 1,
    loading: false,
    error: null,
    submitLoading: false,
    submitError: null,
  },
  reducers: {
    clearGrievanceError(state) {
      state.error = null;
      state.submitError = null;
    },
  },
  extraReducers: (builder) => {
    // fetchGrievances
    builder
      .addCase(fetchGrievances.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchGrievances.fulfilled, (state, action) => {
        state.items = action.payload.items;
        state.total = action.payload.total;
        state.page = action.payload.page;
        state.totalPages = action.payload.totalPages;
        state.loading = false;
      })
      .addCase(fetchGrievances.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

    // createGrievance
    builder
      .addCase(createGrievance.pending, (state) => {
        state.submitLoading = true;
        state.submitError = null;
      })
      .addCase(createGrievance.fulfilled, (state, action) => {
        state.items.unshift(action.payload);
        state.submitLoading = false;
      })
      .addCase(createGrievance.rejected, (state, action) => {
        state.submitLoading = false;
        state.submitError = action.payload;
      });

    // updateGrievance
    builder
      .addCase(updateGrievance.pending, (state) => {
        state.submitLoading = true;
        state.submitError = null;
      })
      .addCase(updateGrievance.fulfilled, (state, action) => {
        const idx = state.items.findIndex((g) => g._id === action.payload._id);
        if (idx !== -1) state.items[idx] = action.payload;
        state.submitLoading = false;
      })
      .addCase(updateGrievance.rejected, (state, action) => {
        state.submitLoading = false;
        state.submitError = action.payload;
      });

    // deleteGrievance
    builder
      .addCase(deleteGrievance.fulfilled, (state, action) => {
        state.items = state.items.filter((g) => g._id !== action.payload);
      })
      .addCase(deleteGrievance.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

export const { clearGrievanceError } = grievanceSlice.actions;
export default grievanceSlice.reducer;
